import { ApiService }     from '../../app-lite/api/api.service';
import { TableService }      from '../../app-lite/table/table.service';
import { SessionService } from '../../app-lite/sessions/session.service';
import { AssemblyPaymentsService } from './assembly-payments.service.ajs';

import AssemblyPaymentsSettingsHtml from './assembly-payments.settings.html';

export function AssemblyPaymentsStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'AssemblyPaymentsSettingsCtrl',
    name       : 'app.assembly-payments-settings',
    templateUrl: AssemblyPaymentsSettingsHtml,
    url        : '/assembly_payments_settings',
    resolve    : {
      integrations: ( workshopAPI : ApiService ) => workshopAPI.get('/company_integrations'),
      session     : ( sessionObjAPI : SessionService ) => sessionObjAPI.refresh(),
      terminals   : ( assemblyPaymentsApi : AssemblyPaymentsService ) => assemblyPaymentsApi.getTerminals()
    }
  });
};